import React from "react";

import SeptaModeIcon from "../septa-icons";

import ModeIconRenderer from "./mode-icon-renderer";

export default {
  title: "Icons/SeptaModeIcon",
  component: SeptaModeIcon
};

export const SeptaModeIconExamples = () => (
  <ModeIconRenderer component={SeptaModeIcon} />
);
